export const normalizeSelectValue = value => (
  Array.isArray(value) || typeof value === 'undefined' || value === null
    ? (value || [])
    : [value]
)

export const toDataURL = url => fetch(url)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  }))

export const hex2a = hex => {
  let str = ''
  for (let i = 0; i < hex.length; i += 2) str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  return str
}

export const normalizeFiles = files => {
  const arr = files.reduce((acc, el) => {
    const data = `${el.name};${el.src}`
    acc.push(data)
    return acc
  }, [])
  return arr
}

export const getFileName = file => {
  let obj = null
  if (file) {
    const one = 1
    const lastIndexOf = file.lastIndexOf('/') + one
    obj = {
      src: file,
      name: file.substr(lastIndexOf),
    }
  }
  return obj
}
